import moment from 'moment';

const initialState = {
    fetching: false,
    changing: false,
    fetched: false,
    error: null
};

export default function reducer(state = initialState, action) {
    state = Object.assign({}, initialState, state);

    switch (action.type) {
        case "UPDATE_MESSENGER_SHIFT_STATUS_PENDING": {
            const newUsers = [...state.users];
            for (let user of newUsers) {
                if (user.id === action.meta.messengerId)
                    user.profiles.messenger.isCurrentlyOnShift = action.meta.isOnShift
            }

            return {
                ...state,
                users: newUsers,
                changing: true
            }
        }
        case "UPDATE_MESSENGER_SHIFT_STATUS_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "UPDATE_MESSENGER_SHIFT_STATUS_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "UPDATE_MESSENGER_AVAILABILITY_PENDING": {
            const newUsers = [...state.users];
            for (let user of newUsers) {
                if (user.id === action.meta.messengerId) {
                    user.profiles.messenger.isCurrentlyAvailable = action.meta.isAvailable;
                    user.profiles.messenger.isWhileMission = action.meta.isWhileMission;

                    if (action.meta.isAvailable)
                        user.profiles.messenger.lastAvailableTimestamp = moment().utc().format().replace('Z', '+00:00');
                    else
                        user.profiles.messenger.lastNonAvailableTimestamp = moment().utc().format().replace('Z', '+00:00');
                }
            }

            return {
                ...state,
                users: newUsers,
                changing: true
            }
        }
        case "UPDATE_MESSENGER_AVAILABILITY_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "UPDATE_MESSENGER_AVAILABILITY_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "UPDATE_MESSENGER_AVAILABILITY_UI": {
            const newUsers = [...state.users];
            for (let user of newUsers) {
                if (user.id === action.meta.messengerId) {
                    user.profiles.messenger.isCurrentlyAvailable = action.meta.isAvailable;
                    user.profiles.messenger.isWhileMission = action.meta.isWhileMission;

                    if (action.meta.isAvailable)
                        user.profiles.messenger.lastAvailableTimestamp = moment().utc().format().replace('Z', '+00:00');
                    else
                        user.profiles.messenger.lastNonAvailableTimestamp = moment().utc().format().replace('Z', '+00:00');
                }
            }

            return {
                ...state,
                users: newUsers
            }
        }
    }

    return state;
}